import { Rastreador, Veiculo } from '../../../class';
import { clienteAdminMixins } from './cliente-admin-mixins';

export const veiculosAdminMixins = {
    data () {
        return {
            veiculo: null,
            posicao: null,
            interval: null,
            positionSource: null,
            tracker: {},
        };
    },
    props: {
        rastreador: {
            default: null
        }
    },
    mixins: [
        clienteAdminMixins
    ],

    async beforeMount(){
        this.startPositionStream();
        this.interval = setInterval(() => {
            this.loadTracker(this.rastreador.id_rastreador);
        }, 45000);
        this.tracker = this.rastreador;
    },

    async beforeDestroy () {
        clearInterval(this.interval);
        this.stopPositionStream();
    },

    methods: {
        async loadVeiculo(id_veiculo){
            this.veiculo = await Veiculo.byPK(id_veiculo);
            if (this.veiculo) {
                await this.loadCliente(this.veiculo.id_cliente);
            }
        },

        async loadTracker(id){
            if (id) {
                this.tracker = await Rastreador.byPK(id);
            }
        },

        startPositionStream () {
            this.stopPositionStream();
            this.positionSource = Rastreador.subscribeLastPositionStream(
                this.rastreador.id_rastreador,
                {
                    onPosition: (position) => this.handlePosition(position),
                    onLocalization: (localization) => this.handleLocalization(localization),
                    onError: () => console.error('Erro no stream de last-position'),
                }
            );
        },

        stopPositionStream () {
            if (this.positionSource) {
                this.positionSource.close();
                this.positionSource = null;
            }
        },

        handlePosition (position) {
            this.posicao = position;
            if (this.posicao.id_veiculo && !this.veiculo) {
                return this.loadVeiculo(this.posicao.id_veiculo);
            }
        },

        handleLocalization (localization) {
            this.posicao.localization = localization;
        },
    }
};

